import { buildBase, DASHBOARD_BASE } from "./constants";

const BASE = buildBase("events");

export const EVENTS_ROUTES = (() => {
  /*
    ======================================================
    ADD ALL BASIC ROUTES HERE
    ======================================================
  */
  const basicRoutes = {
    ROOT: BASE,
    LIST: BASE,
    TRACKING_LINKS: `${BASE}/tracking-links`,
  };

  /*
    ======================================================
    ADD ALL ROUTES THAT REQUIRE NESTING BELOW
    ======================================================
  */
  const EVENTS_ROOT = BASE;
  const EVENTS = {
    editAttraction: (slug: string) => `${EVENTS_ROOT}/${slug}/edit-attraction`,
  };

  const DISCOUNTS_ROOT = `${BASE}/discounts`;
  const DISCOUNTS = {
    ROOT: DISCOUNTS_ROOT,
    CREATE: `${DISCOUNTS_ROOT}/create`,
    EDIT: `${DISCOUNTS_ROOT}/edit`,
  };

  const BULK_ACTIONS_ROOT = `${BASE}/bulk-actions`;
  const BULK_ACTIONS = {
    ROOT: BULK_ACTIONS_ROOT,
    detail: (id: string | number) => `${BULK_ACTIONS_ROOT}/${id}`,
  };

  const WAITLISTS_ROOT = `${DASHBOARD_BASE}/waitlists`;
  const WAITLISTS = {
    ROOT: WAITLISTS_ROOT,
    detail: (id: string | number) => `${WAITLISTS_ROOT}/${id}`,
    EVENT_WAITLIST: (eventSlug: string) =>
      `${DASHBOARD_BASE}/event/${eventSlug}/waitlist`,
  };

  const UPGRADE_PATHS_ROOT = `${BASE}/upgrade-paths`;
  const UPGRADE_PATHS = {
    ROOT: UPGRADE_PATHS_ROOT,
  };

  return {
    ...basicRoutes,
    EVENTS,
    DISCOUNTS,
    BULK_ACTIONS,
    WAITLISTS,
    UPGRADE_PATHS,
  };
})();
